import { captureException } from 'marketing-site/lib/sentry'
import React from 'react'
import { ArrowIcon } from './icons/ArrowIcon'
import { CheckmarkIcon } from './icons/CheckmarkIcon'
import { FeatureChechmarkIcon } from './icons/FeatureCheckmarkIcon'
import { GrowIcon } from './icons/GrowIcon'
import { MoreIcon } from './icons/MoreIcon'
import { PlayIcon } from './icons/PlayIcon'
import { PlusIcon } from './icons/PlusIcon'

import AppsIcon from 'marketing-site/src/images/productIcons/product-apps.svg'
import ArticlesIcon from 'marketing-site/src/images/productIcons/product-articles.svg'
import AtIcon from 'marketing-site/src/images/productIcons/product-at.svg'
import BotsIcon from 'marketing-site/src/images/productIcons/product-bots.svg'
import ContactsIcon from 'marketing-site/src/images/productIcons/product-contacts.svg'
import InboxIcon from 'marketing-site/src/images/productIcons/product-inbox.svg'
import MessengerIcon from 'marketing-site/src/images/productIcons/product-messenger.svg'
import NotificationsIcon from 'marketing-site/src/images/productIcons/product-notifications.svg'
import OutboundIcon from 'marketing-site/src/images/productIcons/product-outbound.svg'
import ProductTourIcon from 'marketing-site/src/images/productIcons/product-product-tours.svg'
import ReportsIcon from 'marketing-site/src/images/productIcons/product-reports.svg'
import SeriesIcon from 'marketing-site/src/images/productIcons/product-series.svg'
import SurveysIconNew from 'marketing-site/src/images/productIcons/product-surveys.svg'
import UsersIcon from 'marketing-site/src/images/productIcons/product-user.svg'

export enum Icon {
  Arrow = 'Arrow',
  Play = 'Play',
  More = 'More',
  Plus = 'Plus',
  FeatureCheckmark = 'FeatureCheckmark',
  Checkmark = 'Checkmark',
  Grow = 'Grow',
}

export function renderIconSVG(icon: Icon, classes = '') {
  switch (icon) {
    case Icon.Play:
      return <PlayIcon classes={classes} />
    case Icon.Arrow:
      return <ArrowIcon classes={classes} />
    case Icon.More:
      return <MoreIcon classes={classes} />
    case Icon.FeatureCheckmark:
      return <FeatureChechmarkIcon classes={classes} />
    case Icon.Checkmark:
      return <CheckmarkIcon classes={classes} />
    case Icon.Plus:
      return <PlusIcon classes={classes} />
    case Icon.Grow:
      return <GrowIcon classes={classes} />
    default:
      return null
  }
}

export function getTypedIcon(icon: string): Icon {
  // @ts-ignore
  if (Icon[icon] === undefined) {
    captureException(new Error(`Icon not recognized: ${icon}`))
  }

  // @ts-ignore
  return Icon[icon] as Icon
}

enum ProductIcons {
  Outbound,
  Apps,
  Inbox,
  Surveys,
  Bots,
  Reports,
  Series,
  ProductTours,
  Messenger,
  Notifications,
  Contacts,
  User,
  Articles,
  AtIcon,
}
export const defaultProductIconSet = {
  [ProductIcons.Apps]: AppsIcon,
  [ProductIcons.Articles]: ArticlesIcon,
  [ProductIcons.AtIcon]: AtIcon,
  [ProductIcons.Bots]: BotsIcon,
  [ProductIcons.Contacts]: ContactsIcon,
  [ProductIcons.Inbox]: InboxIcon,
  [ProductIcons.Messenger]: MessengerIcon,
  [ProductIcons.Notifications]: NotificationsIcon,
  [ProductIcons.Outbound]: OutboundIcon,
  [ProductIcons.ProductTours]: ProductTourIcon,
  [ProductIcons.Reports]: ReportsIcon,
  [ProductIcons.Series]: SeriesIcon,
  [ProductIcons.Surveys]: SurveysIconNew,
  [ProductIcons.User]: UsersIcon,
}
